import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { OnNavigationLeaveService, OnNavigationLeave } from '../services/on-navigation-leave.service';

export const OnNavigationLeaveGuard: CanDeactivateFn<OnNavigationLeave> = (component: OnNavigationLeave) => {
    const guard = inject(OnNavigationLeaveService);
    return guard.canDeactivate(component);
};